import script from "./SwiperJs.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperJs.vue?vue&type=script&setup=true&lang=js"

import "./SwiperJs.vue?vue&type=style&index=0&id=44eb3e0c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44eb3e0c"]])

export default __exports__